import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { PaymentService } from '../../../../common/service/payment.service';
import { WindowService } from '../../../../common/service/window.service';
import { ModalService } from '../../../../common/service/modal.service';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { ModalRouteService } from '../../../../common/service/modal-route.service';
import { AmorphicService } from '../../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { PaymentFormComponent } from '../paymentForm';

@Component({
  selector: 'payment-form-component-mmdirect',
  templateUrl: './paymentForm.mmdirect.html',
  providers: [PaymentService, WindowService, ModalService],
})
export class PaymentFormComponentMMDirect extends PaymentFormComponent {
  @Input() dismiss;

  constructor(
    paymentService: PaymentService,
    windowService: WindowService,
    modalService: ModalService,
    modalRouteService: ModalRouteService,
    router: Router,
    fb: FormBuilder,
    cdRef: ChangeDetectorRef,
    amorphicService: AmorphicService
  ) {
    super(paymentService, windowService, modalService, modalRouteService, router, fb, cdRef, amorphicService);
  }
}
